import Select from 'react-select';
import React, { useState, useEffect } from 'react'
import ToastNotification from '../../../components/ToastNotification';
import axios from 'axios'
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdLocalPrintshop } from "react-icons/md";
import { FaSearch } from "react-icons/fa";
import { TfiControlShuffle } from 'react-icons/tfi';

function CostingReport() {

  const [noteType, setNoteType] = useState(null);
  const [fetchData, setfetchData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [branchDetail, setBranchDetail] = useState([])
  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  const [allData, setAllData] = useState([]);
  // const [filteredData, setFilteredData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [company, setCompany] = useState([]);

const [selectedBranch, setSelectedBranch] = useState("");

  const reportOptions = [
    { value: 'cost_allocation', label: 'Cost Allocation' },

  ]

  const handleSearch = async (e) => {
    e.preventDefault();

    if (!noteType?.value) {
      setToast('Please select a report type', 'warning');
      return;
    }
    if (!fromDate || !toDate) {
      setToast('Please select From Date and To Date', 'warning');
      return;
    }

    try {
      const params = {
        noteType: noteType.value,
        from_date: fromDate,
        to_date: toDate
      };

      console.log({ fromDate, toDate });

      const result = await axios.get(
        'https://api.skyguard.group/api/get-costing-report',
        { params }
      );

      const resultData = result?.data || [];

      setfetchData(resultData);
      console.log(resultData);

    } catch (error) {
      console.error('❌ Error fetching report:', error);
      setToast('Error fetching report. Please try again.', 'danger');
    }
  };


//   const groupedData = [];

// fetchData.forEach(item => {
//   try {
//     const parsed = JSON.parse(JSON.parse(item.tableRow));

//     parsed.forEach(row => {
//       (row.cost_allocation || []).forEach(cost => {
//         const empName = cost.cost_account_name;

//         let existing = groupedData.find(e => e.name === empName);

//         if (!existing) {
//           existing = {
//             name: empName,
//             entries: []
//           };
//           groupedData.push(existing);
//         }

//         existing.entries.push({
//           account: row.account?.label,
//           amount: cost.amount,
//           payment_date: item.payment_date,
//           branch: item.branchName,
//           type: row.type,
//            payment_type: item.payment_type, 
//          id: item.inv_no 
//         });
//       });
//     });

//   } catch (err) {
//     console.log("Parse error:", err);
//   }
// });


const groupedData = [];

fetchData.forEach(item => {
  try {
    const parsed = JSON.parse(JSON.parse(item.tableRow));

    parsed.forEach(row => {
      (row.cost_allocation || []).forEach(cost => {
        const empName = cost.cost_account_name;
        const accountName = row.account?.label;

        let emp = groupedData.find(e => e.name === empName);

        if (!emp) {
          emp = {
            name: empName,
            accounts: []   // 👈 changed from entries → accounts
          };
          groupedData.push(emp);
        }

        let acc = emp.accounts.find(a => a.account === accountName);

        if (!acc) {
          acc = {
            account: accountName,
            entries: []
          };
          emp.accounts.push(acc);
        }

        acc.entries.push({
          amount: cost.amount,
          payment_date: item.payment_date,
          branch: item.branchName,
          type: row.type,
          payment_type: item.payment_type,
          id: item.inv_no
        });
      });
    });

  } catch (err) {
    console.log("Parse error:", err);
  }
});


const employeeOptions = [...new Set(groupedData.map(e => e.name))];



const branchOptions = [
  ...new Set(
    groupedData.reduce((acc, e) => {
      if (typeof e.name === "string") {
        const match = e.name.match(/\((.*?)\)/);
        if (match?.[1]) acc.push(match[1]);
      }
      return acc;
    }, [])
  )
];


// const filteredData = groupedData.filter(emp => {
//   const matchesEmployee = selectedEmployee
//     ? emp.name === selectedEmployee
//     : true;

//   const branchMatch = emp.name.match(/\((.*?)\)/);
//   const branchName = branchMatch ? branchMatch[1] : "";

//   const matchesBranch = selectedBranch
//     ? branchName === selectedBranch
//     : true;

//   return matchesEmployee && matchesBranch;
// });


const filteredData = groupedData.filter(emp => {
  const employeeName = emp?.name || "";

  const matchesEmployee = selectedEmployee
    ? employeeName === selectedEmployee
    : true;

  const branchName =
    employeeName.match(/\((.*?)\)/)?.[1] || "";

  const matchesBranch = selectedBranch
    ? branchName === selectedBranch
    : true;

  return matchesEmployee && matchesBranch;
});


  const handlePrint = () => {
    const content = document.getElementById("exportTable");

    if (!content) return;

    const printWindow = window.open("", "", "width=900,height=700");

    printWindow.document.write(`
  <html>
    <head>
      <title>AMC Report</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          padding: 10px;
          margin: 0;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          table-layout: auto;
          word-wrap: break-word;
        }

        th, td {
          border: 1px solid black;
          padding: 6px;
          font-size: 12px;
        }

        /* Prevent overflow */
        div {
          overflow: visible !important;
        }

        /* Fit content inside page */
        @page {
          size: A4 landscape;
          margin: 10mm;
        }
      </style>
    </head>
    <body>
      ${content.outerHTML}
    </body>
  </html>
`);
    printWindow.document.close();
    printWindow.focus();


    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
  };

  return (
    <div className='main-section'>
      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

        <h3 className='my-3 fw-bold fs-5 golos'> Report</h3>

        <div className="row g-3 align-items-end">
          <div className="col-md-4">
            <label className='fw-bold'>Select Report</label>
            <Select
              options={reportOptions}
              placeholder="Choose Type ..."
              id="source"
              value={noteType}

              onChange={(selected) => {
                setNoteType(selected);
                setfetchData([]);
              }}
            />
          </div>

          <div className="col-md-4">
            <label className='fw-bold'>From Date</label>
            <input
              type="date"
              className="form-control"
              name="from_date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="col-md-4">
            <label className='fw-bold'>To Date</label>
            <input
              type="date"
              className="form-control"
              name="to_date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>


          <div className="col-md-12 d-flex justify-content-end align-items-end">
     
            <FaSearch size={26} className="ms-1 text-primary"
              style={{ cursor: "pointer" }}
              title="Search"
              onClick={handleSearch}
            />

            <MdLocalPrintshop
              size={26}
              className="ms-1 text-success"
              onClick={handlePrint}
              style={{ cursor: "pointer" }}
              title="Print "
            />
          </div>


          <div className="d-flex gap-3 mb-3">

  {/* Employee Filter */}
  <select
    className="form-select"
    value={selectedEmployee}
    onChange={(e) => setSelectedEmployee(e.target.value)}
  >
    <option value="">All Employees</option>
    {employeeOptions.map((emp, i) => (
      <option key={i} value={emp}>{emp}</option>
    ))}
  </select>

  {/* Branch Filter */}
  <select
    className="form-select"
    value={selectedBranch}
    onChange={(e) => setSelectedBranch(e.target.value)}
  >
    <option value="">All Branches</option>
    {branchOptions.map((branch, i) => (
      <option key={i} value={branch}>{branch}</option>
    ))}
  </select>

</div>

          <div id="exportTable" className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
            {noteType?.value === 'cost_allocation' && (
                 <table className='table table-bordered table-striped table-hover text-center align-middle'>
              <thead className="table-info">
  <tr>
    <th>SN</th>
    <th>Account</th>
    <th>Amount</th>
    <th>Type</th>
    <th>Payment Date</th>
    <th>DOC No</th>
  </tr>
</thead>

{/* 
       <tbody>
  {filteredData.length > 0 ? (
    filteredData.map((emp, i) => (
      <React.Fragment key={i}>
        
  
        <tr className="table-primary">
          <td colSpan="6">
            <strong>{emp.name}</strong>
          </td>
        </tr>

        {emp.entries.map((entry, idx) => (
          <tr key={idx}>
            <td>{idx + 1}</td>
            <td>{entry.account}</td>
            <td>{entry.amount}</td>
            <td>{entry.type}</td>
            <td>{entry.payment_date}</td>
    <td>
  {entry.payment_type === "bank_payment"
    ? `BP/${entry.id}/${entry.branch}`
    : entry.payment_type === "cash_payment"
    ? `CP/${entry.id}/${entry.branch}`
    : ""}
</td>
          </tr>
        ))}
      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody> */}


<tbody>
  {filteredData.length > 0 ? (
    filteredData.map((emp, i) => (
      <React.Fragment key={i}>

        {/* Employee Row */}
        <tr className="table-primary">
          <td colSpan="6"><strong>{emp.name}</strong></td>
        </tr>

        {/* Account-wise grouping */}
        {emp.accounts.map((acc, j) => (
          <React.Fragment key={j}>

            {/* Account Row */}
            <tr className="table-secondary">
              <td colSpan="6"><strong>{acc.account}</strong></td>
            </tr>

            {/* Entries */}
            {acc.entries.map((entry, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{acc.account}</td>
                <td>{entry.amount}</td>
                <td>{entry.type}</td>
                <td>{entry.payment_date}</td>
                <td>
                  {entry.payment_type === "bank_payment"
                    ? `BP/${entry.id}/${entry.branch}`
                    : entry.payment_type === "cash_payment"
                    ? `CP/${entry.id}/${entry.branch}`
                    : ""}
                </td>
              </tr>
            ))}

          </React.Fragment>
        ))}

      </React.Fragment>
    ))
  ) : (
    <tr>
      <td colSpan="6">No data found</td>
    </tr>
  )}
</tbody>
              </table>
            )}
          </div>


        </div>
      </div>
    </div>
  )
}

export default CostingReport